document.addEventListener('DOMContentLoaded', function () {
  var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouchDevice) {
    return;
  }

  var sections = document.querySelectorAll('[data-section-type="product"]');
  sections.forEach(function (section) {
    var mediaContainer = section.querySelector('.product-media');
    if (!mediaContainer) {
      return;
    }

    var mediaWrappers = Array.from(
      mediaContainer.querySelectorAll('[data-product-single-media-wrapper]')
    );

    if (mediaWrappers.length < 2) {
      return;
    }

    var startX = 0;
    var startY = 0;
    var lastX = 0;
    var lastY = 0;
    var isTracking = false;
    var SWIPE_THRESHOLD = 45;

    var getCurrentIndex = function () {
      var current = mediaWrappers.findIndex(function (wrapper) {
        return !wrapper.classList.contains('hide');
      });
      return current === -1 ? 0 : current;
    };

    var showIndex = function (targetIndex) {
      var currentIndex = getCurrentIndex();
      if (
        targetIndex === currentIndex ||
        targetIndex < 0 ||
        targetIndex >= mediaWrappers.length
      ) {
        return;
      }

      mediaWrappers[currentIndex].classList.add('hide');
      mediaWrappers[targetIndex].classList.remove('hide');
      section.dispatchEvent(
        new CustomEvent('product-media:change', { detail: { index: targetIndex } })
      );
    };

    var handleTouchStart = function (event) {
      if (window.innerWidth > 768) {
        return;
      }
      var touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      lastX = startX;
      lastY = startY;
      isTracking = true;
    };

    var handleTouchMove = function (event) {
      if (!isTracking || window.innerWidth > 768) {
        return;
      }
      var touch = event.touches[0];
      lastX = touch.clientX;
      lastY = touch.clientY;
    };

    var handleTouchEnd = function () {
      if (!isTracking || window.innerWidth > 768) {
        isTracking = false;
        return;
      }

      var deltaX = lastX - startX;
      var deltaY = lastY - startY;
      isTracking = false;

      // Ignore mostly vertical gestures.
      if (Math.abs(deltaX) < Math.abs(deltaY)) {
        return;
      }

      if (Math.abs(deltaX) < SWIPE_THRESHOLD) {
        return;
      }

      var currentIndex = getCurrentIndex();
      if (deltaX < 0) {
        showIndex(currentIndex + 1);
      } else {
        showIndex(currentIndex - 1);
      }
    };

    mediaContainer.addEventListener('touchstart', handleTouchStart, {
      passive: true
    });
    mediaContainer.addEventListener('touchmove', handleTouchMove, {
      passive: true
    });
    mediaContainer.addEventListener('touchend', handleTouchEnd);
    mediaContainer.addEventListener('touchcancel', function () {
      isTracking = false;
    });
  });
});
